import * as yup from 'yup'

export const validateUpdateStores = yup.object().shape({
    name: yup
    .string()
    .min(2, 'El NOMBRE debe tener más de 1 caracteres'),
    phone: yup
    .string()
    .min(2, 'El TELÉFONO debe tener más de 1 caracteres'),
    // phone2: yup
    // .string()
    // .nullable()
    // .min(2, 'El TELÉFONO 2 debe tener más de 1 caracteres'),
    email: yup
    .string()
    .nullable()
    .email('Introduzca un correo electrónico válido.'),
    schedule: yup
    .string()
    .nullable()
    .min(2, 'El HORARIO debe tener más de 1 caracteres'),
    address: yup
    .string()
    .min(2, 'LA DIRECCIÓN debe tener más de 1 caracteres'),
    location_city_id:yup
    .string()
    .min(1, 'LA CIUDAD debe tener más de 1 caracteres'),
})